/**
 * sessionStorage key used to stash a pending onboarding-modal-open redirect
 * (e.g. "/flyboard?showonboardingprogresstraining=true", the target that
 * `/onboarding`, `/onboarding0`-`/onboarding9` and `/retakeonboarding`
 * resolve to — see app.routing.ts) when AuthGuardService bounces a
 * logged-out user to /session/signin. AuthGuardService's redirect is a hard
 * page navigation (window.open(..., "_self")), which wipes AuthService's
 * in-memory redirectUrl, so the pending destination has to survive in
 * sessionStorage instead — same pattern as CAMPAIGN_REDIRECT_STORAGE_KEY.
 * Consumed once (read + cleared) by AuthService after login completes.
 */
export const ONBOARDING_REDIRECT_STORAGE_KEY = "fms_onboarding_redirect_url";
